import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import './style.scss'

@HocDialogComponent
export default class InfopaidData extends Component {
    static propTypes = {
        closeDialog: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
    }

    onButtonClick = (buttonType) => {
        if (buttonType === 'ok') {
            const { type, closeDialog } = this.props

            closeDialog(type)
        }
    }

    defineHeader = () => ({
        text: <FormattedMessage id={`${LOCALE_PREFIX}.title`} />,
        icon: 'info',
    })

    defineFooter = () => [
        {
            type: 'ok',
            text: <FormattedMessage id={`${LOCALE_PREFIX}.button.ok`} />,
        },
    ]

    render() {
        return (
            <div className={'info-paid-data-dialog'}>
                <div className={'text'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.text`} />
                </div>
                <div className={'contact'}>
                    <div className={'email'}>
                        <a href={'mailto:podpora.cz@dnb.com'} target={'_blank'} rel={'noopener noreferrer'}>
                            {'podpora.cz@dnb.com'}
                        </a>
                    </div>
                    <div className={'phone'}>
                        <a href={'tel:+420274800000'} target={'_blank'} rel={'noopener noreferrer'}>
                            {'274 800 000'}
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
